"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPunchesForMealLockoutValdn = void 0;
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../utils/DateManagement");
const getPunchesForMealLockoutValdn = (timespanPunchGroups = [], selectedDate) => {
    const punchGroupForSelectedDate = timespanPunchGroups.reduce((accuPunchGroup, currPunchGroup) => {
        if (currPunchGroup.timespanGroupId !== accuPunchGroup.timespanGroupId) {
            currPunchGroup.punchWithTimespans.forEach((punchWithTimespan) => {
                var _a, _b;
                const punchTime = ((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime.timestamp) ||
                    ((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime.timestamp);
                const punchDateTime = punchTime
                    ? luxon_1.DateTime.fromISO(punchTime)
                    : null;
                if (punchDateTime &&
                    ((0, DateManagement_1.areDatesEqual)(selectedDate, punchDateTime) ||
                        (0, DateManagement_1.areDatesEqual)(selectedDate.minus({ days: 1 }), punchDateTime) ||
                        (0, DateManagement_1.areDatesEqual)(selectedDate.plus({ days: 1 }), punchDateTime))) {
                    accuPunchGroup.punchWithTimespans.push(punchWithTimespan);
                }
            });
            accuPunchGroup.timespanGroupId = currPunchGroup.timespanGroupId;
        }
        return accuPunchGroup;
    }, { punchWithTimespans: [], timespanGroupId: '' });
    return punchGroupForSelectedDate.punchWithTimespans;
};
exports.getPunchesForMealLockoutValdn = getPunchesForMealLockoutValdn;
